import { Injectable, OnDestroy, inject } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';

import { Subscription } from 'rxjs';

import { unsubscribe } from '@fcom/core';
import { LanguageService } from '@fcom/ui-translate';

@Injectable({ providedIn: 'root' })
export class DatePickerLocalizationService extends MatDatepickerIntl implements OnDestroy {
  private languageService = inject(LanguageService);

  private subscription = new Subscription();

  constructor() {
    super();
    this.subscription.add(
      this.languageService
        .translate<Record<string, string>>('SERVICE_FORMS.NTServiceForms.helpers.datePicker')
        .subscribe((values) => this.attachTranslations(values))
    );
  }

  attachTranslations(values: Record<string, string>): void {
    this.calendarLabel = values.calendarLabel;
    this.openCalendarLabel = values.openCalendarLabel;
    this.prevMonthLabel = values.prevMonthLabel;
    this.nextMonthLabel = values.nextMonthLabel;
    this.prevYearLabel = values.prevYearLabel;
    this.nextYearLabel = values.nextYearLabel;
    this.prevMultiYearLabel = values.prevMultiYearLabel;
    this.nextMultiYearLabel = values.nextMultiYearLabel;
    this.switchToMonthViewLabel = values.switchToMonthViewLabel;
    this.switchToMultiYearViewLabel = values.switchToMultiYearViewLabel;
  }

  ngOnDestroy(): void {
    unsubscribe(this.subscription);
  }
}
